<template>
    <div>
         <el-tag type="info" style="width:1100px;margin:0 auto 15px;display:block;font-size:14px">
            <p>云签章录入采集步骤说明：</p>
            <p>1.录入需要采集签章的人员信息，提交后不可修改。每个帐号只能录入一个人员。</p>
            <p>2.提交人员信息完成后，下载APP使用录入完成的信息登录并进行采集。采集成功后，可正常使用签章功能。</p>
        </el-tag>
        <my-form 
            class="form-page" 
            v-model="form" table 
            label-width="180px" 
            @cancle="cancleHandler" 
            @submit="submit">
               
                <el-form-item 
                    label="姓名" 
                    prop="truename" 
                    :rules="newRule('姓名', 'required')"
                    class="table-full-row">
                        <el-input v-model="form.truename" :disabled="form.shbj=='1'||form.hasseal=='1'"></el-input>
                </el-form-item>
                <el-form-item 
                    label="手机号" 
                    prop="mobile" 
                    :rules="newRule('手机号', 'required', 'mobile')"
                    class="table-full-row">
                        <el-input v-model="form.mobile" :disabled="form.shbj=='1'||form.hasseal=='1'"></el-input>
                </el-form-item>
                <el-form-item 
                    label="身份证号" 
                    prop="idcard" 
                    :rules="proidcard"
                    class="table-full-row">
                        <el-input v-model="form.idcard" :disabled="form.shbj=='1'||form.hasseal=='1'"></el-input>
                </el-form-item>
                <div style="width:100%">
                    <el-alert
                        v-if="form.hasseal=='1'"
                        title="已采集签章"
                        type="success"
                        :closable="false"
                        center
                        show-icon>
                    </el-alert>
                    <el-alert
                        v-else
                        title="未采集签章"
                        type="warning"
                        :closable="false"
                        center
                        show-icon>
                    </el-alert>
                </div>

                <template slot="btn" slot-scope="scope">
                    <el-button 
                        v-if="form.shbj!='1'&&form.hasseal!='1'" 
                        @click="saveHandler(1, scope.submitHandler)" 
                        type="primary" 
                        icon="el-icon-circle-check">
                            提交
                    </el-button>
                    <el-button 
                        v-if="form.shbj!='1'&&form.hasseal!='1'" 
                        @click="saveHandler(0, scope.submitHandler)" 
                        type="warning" 
                        icon="el-icon-circle-check">
                            保存
                    </el-button>
                </template>
        </my-form>
        
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN],
    data() {
        return{
            form:{},
            

        }
    },
    computed: {
        //身份证验证
        proidcard(){
            var rule = this.newRule('身份证号', 'required');

            return [
                ...rule,
                {
                    validator(rules, value, callback) {
                        if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                            return callback(new Error('身份证号格式错误'));
                        }
                        callback();
                    },
                    trigger: ['blur']
                }
            ]
        },
    },
    watch: {
        
    },
    methods: {
       
        getuser(){
            var that = this;
            that.$get(`${that.getGetters('mngUrl')}/cloudseal/getuser`,(data, res) => {
                that.form = data;
            })
        },
        // 保存
        saveHandler(type, cb){
            this.form.shbj = type;
            cb && cb();
        },
        submit(){
            var that = this;
            that.$post(`${that.getGetters('mngUrl')}/cloudseal/adduser`,that.form, data => {
                ShowMsg('保存成功','success');
                that.getuser();
            }) 
        },
    },
    created() {
        this.getuser();
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    /deep/.el-form .el-alert{ width: 300px; margin: 15px auto 0; }
</style>
